<template>
  <div class="top-aside">
    <!-- <v-btn class="icon"
           icon
           @click="miniVariant">
      <mrc_ess_svgIcon icon-class="service"
                       style="font-size:24px" />
    </v-btn> -->
    <slot name="btnDrawer">
    </slot>
    <div class="rightFun">
      <span class="mr-2" v-if="$store.state.topcompanylist.length > 1">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <!--dark color="#f2f2f2" style="cursor: pointer !important"       width="160" -->
            <v-btn rounded :elevation="0" style="padding: 0 4px !important;cursor: pointer !important;" text height="32"
              v-bind="attrs" v-on="on">
              <!--   overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  width: 80px; -->
              <span style="
                  text-align: left;
                  font-size: 14px;
                  color: #393939;" class="text-capitalize mx-1">
                {{ INT(companyName) }}
              </span>
              <v-icon class="material-icons" style="color: #393939"> arrow_drop_down </v-icon>
            </v-btn>
          </template>

          <v-list dense>
            <v-list-item v-for="(item, index) in topcompanylist" :key="index" @click="savecompany(item)">
              <v-list-item-title>
                {{ item.org_level_name }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </span>
      <!-- <span class="mr-2"
            v-else>
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#f2f2f2"
                   rounded
                   :elevation='0'
                   v-if="showSelectCompany"
                   min-width='150'
                   dark
                   v-bind="attrs"
                   v-on="on">
              <span style="justify-content:space-between;width:100%;display:flex;align-items:center">
                <span class="text-capitalize"
                      style="color:#393939">{{companyName}}</span>
              </span>-
            </v-btn>
          </template>
        </v-menu>
      </span> -->
      <!-- 分割线------------------------------------langage -->
      <v-menu offset-y v-if="$store.state.currentCompanyLanguage.length > 1" transition="scale-transition">
        <!-- color="#f2f2f2" -->
        <template v-slot:activator="{ on, attrs }">
          <v-btn rounded :elevation="0" text height="32" style="cursor: pointer !important;padding: 0 4px !important;"
            v-bind="attrs" v-on="on">
            <!-- <mrc_ess_svgIcon icon-class="outline-language-24px"
                             style="font-size: 24px" /> -->
            <span style="
                text-align: left;
                font-size: 14px;
                color: #393939;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 108px;
              " class="text-capitalize">
              {{ lang_name }}
            </span>
            <v-icon style="color: #393939" class="material-icons">arrow_drop_down</v-icon>
          </v-btn>
        </template>
        <v-list dense class="hover" style="overflow-y: auto; max-height: 500px">
          <v-list-item v-for="item in langList" :key="item.value" @click="lang_change(item)">
            <v-list-item-title>
              {{ item.text }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- <v-menu offset-y
              v-else
              transition="scale-transition">
        <template v-slot:activator="{ on ,attrs}">
          <v-btn color="#f2f2f2"
                 rounded
                 :elevation='0'
                 min-width='125'
                 dark
                 v-bind="attrs"
                 v-on="on">
            <mrc_ess_svgIcon icon-class="outline-language-24px"
                             style="font-size: 23px;" />
            <span style="font-size:15px;color:#393939;">{{lang_name}}</span>
          </v-btn>
        </template>
      </v-menu> -->
      <!-- <v-btn icon>
        <mrc_ess_svgIcon class="mx-3"
                         icon-class="round-notifications-24px"
                         style="font-size: 24px;cursor:pointer !important;" />
      </v-btn> -->
      <span class="mr-5 ml-4">
        <avatar @login_out="login_out" :kc_loading="login_out_loading" />
      </span>
    </div>
  </div>
</template>

<script>
import Cookie from "js-cookie"
import {
  getCurrentList,
  editDefaultLang,
} from "@/service/api/internationalization"
import { switchCompany, loginOut } from "@/service/api/login.js"
import avatar from "./avatar"
import Index from "../../index.vue"

// window.onbeforeunload = function(e) {
//   e = e || window.event

//   // 兼容IE8和Firefox 4之前的版本
//   if (e) {
//     e.returnValue = null
//   }
//   loginOut()
//     .then((res) => {})
//     .catch((err) => {})
//   console.log('shuaxin')
//   // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
//   return null
// }
export default {
  components: { avatar, Index },
  props: {},
  data() {
    return {
      items: ["Foo", "Bar", "Fizz", "Buzz"],
      company: "", //公司高级参照
      companyName: "",
      showSelectCompany: false, login_out_loading: false
    }
  },
  created() { },
  async mounted() {
    this.$mitt.on('logout-start', () => {
      // console.log('logout...')
      this.login_out_loading = true
    })
    this.$mitt.on('logout-end', () => {
      this.login_out_loading = false;
      this.$mitt.off('logout-start')
      this.$mitt.off('logout-end')
      // console.log('logout end!!!')
    })
    if (
      this.$store.state.userData.userType == "2" ||
      this.$store.state.userData.userType == 3
    ) {
      this.showSelectCompany = true
      if (this.$store.state.topcompanylist.length <= 0) {
        await this.$store.dispatch("set_topcompanylist")
      }
      if (this.$store.state.loginStatus) {
        //用户第一次登录进入才会触发，刷新不会触发
        this.companyName = this.$store.state.topcompanylist[0].org_level_name
        this.$store.dispatch(
          "set_currentCompany",
          this.$store.state.topcompanylist[0].uuid || ""
        )
        this.$store.commit(
          "set_currentCompanyClientUuid",
          this.$store.state.topcompanylist[0].client_uuid || ""
        )
      } else {
        const items = this.$store.state.topcompanylist.filter(
          (item) => item.uuid == this.$store.state.currentCompany
        )
        this.companyName = items[0].org_level_name
      }
    }
    if (this.langList.length <= 0) {
      this.$store.dispatch("setCurrentCompanyLanguageList")
    }
  },
  methods: {
    async lang_change(item) {
      this.$store.commit("set_lang", item)
      try {
        await editDefaultLang({ language_code: item.value })
      } catch (err) {
        await editDefaultLang({ language_code: item.value })
      }
    },
    miniVariant() {
      this.$store.commit("set_miniVariant", !this.$store.state.miniVariant)
    },
    login_out() {
      this.$sso_auth.logout()
      // this.$myConfirm({
      //   content: this.$t("message_logoutTip"),
      // })
      //   .then((res) => {
      //     console.log(res)
      //     if (res) {

      //     }
      //     // .then(() => {
      //     //   this.$router.push({
      //     //     name: "login",
      //     //   })
      //     // })
      //     // .catch((err) => { })

      //   })
      //   .catch(() => { })
    },
    savecompany(item) {
      // console.log(item);

      if (this.INT(item.org_level_name) != this.INT(this.companyName)) {
        this.companyName = item.org_level_name
        this.$store.dispatch("set_currentCompany", item.uuid || "")
        this.$store.commit(
          "set_currentCompanyClientUuid",
          item.client_uuid || ""
        )
        this.$store.commit("setCurrentCompanyObj", item)
        switchCompany({ org_level_uuid: item.uuid }).then(async (res) => {
          if (res.code == 200) {
            await this.$store.dispatch("set_userData", res.data)
            await this.$store.dispatch("setCurrentCompanyLanguageList")
            this.$router.push({ name: "dashboard" })
            // window.location.reload()
          }
        })
      }
    },
  },
  computed: {
    langList() {
      return this.$store.state.currentCompanyLanguage
    },
    lang_name() {
      return this.$store.getters.lang_name
    },
    topcompanylist() {
      return this.$store.state.topcompanylist
    },
  },
  watch: {},
}
</script>

<style scoped>
.btn {
  padding: 0 4px !important;
}

.top-aside {
  height: 56px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* .hover:hover {
  background-color: red;
  color: aqua;
} */
.icon {
  display: flex;
  margin-left: 10px;
  cursor: pointer;
}

.top-aside /deep/ .v-select {
  width: 140px;
  height: 35px;
  padding: 0 10px;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  border-top-right-radius: 12px;
  border-bottom-right-radius: 12px;
  background-color: #f2f2f2;
}

.top-aside /deep/ .v-input {
  flex: initial;
}

.top-aside .rightFun {
  /* padding-left: 135px; */
  display: flex;
  /* overflow-y: auto; */
  justify-content: flex-end;
  height: 100%;
  align-items: center;
}

.v-list-item:hover {
  background-color: var(--main-light-color) !important;
}

.v-list-item:hover .v-list-item__title {
  color: var(--main-color) !important;
}
</style>
